module.exports = "<p>\n  audit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/audit/audit.component.html
// module id = ./src/app/views/audit/audit.component.html
// module chunks = main